// extracted by mini-css-extract-plugin
export var centered = "_s-6";
export var flexible = "_s-5";
export var footer = "_s-k";
export var footerBorder = "_s-l";
export var header = "_s-c";
export var headerBorder = "_s-d";
export var headerDefault = "_s-g";
export var headerMedium = "_s-h";
export var headerPadding = "_s-e";
export var iconAndTitle = "_s-f";
export var large = "_s-4";
export var largePadding = "_s-a";
export var medium = "_s-3";
export var mediumPadding = "_s-9";
export var modal = "_s-0";
export var modalContainer = "_s-b";
export var noPadding = "_s-7";
export var skinny = "_s-1";
export var small = "_s-2";
export var smallPadding = "_s-8";
export var subtitle = "_s-j";
export var title = "_s-i";